
import React, { useState, useEffect, useContext } from "react";
import tmdbApi from "../api/tmdbApi";
import { useNavigate } from "react-router-dom";
import Modal from 'react-bootstrap/Modal';
//  import SweetAlert from 'react-bootstrap-sweetalert';
import { contentContext } from "../context/contentContext";
import moment from "moment";
import OTPInput from "otp-input-react";
import SweetAlert from 'react-bootstrap-sweetalert';
let { lambda, country, appname } = window.app;
//  import * as Config from "../constants/Config";

//  import { Row, Col, CardBody, Card, Alert, Container, Form, Input, FormFeedback, Label } from "reactstrap";



const VerifyAccount = () => {
    const [pwd, setPwd] = useState('');
    const [email, setEmail] = useState("");
    const [newEmail,setNewEmail] = useState("");
    const [notFound,setNotFound] = useState(false);
    const [error, setError] = useState('');
    const [success, setSuccess] = useState(false);
    const [BtnLoader,setBtnLoader]=useState(false)
   //  const [success, setSuccess] = useState(false);
   //  const [config, setConfig] = useState({});
    const navigate = useNavigate();
    const [image, setImg] = useState('');
    const [showSessionPopup, setShowSessionPopup] = useState(false);
    const [activeLoad, setActiveLoad] = useState("");
    const [otp, setOtp] = useState('');
    const [resendActive, setResendActive] = useState(false);
    const [otpclass, setOtpClass] = useState(false);
    const [exist, setExist] = useState(false);
    const [showEmailChange,setShowEmailChange ] = useState(false);
    
    const { userData, setUserData, activeMenuObj, setActiveMenuObj, GetUserDataContext,activeMenuId, setActiveMenuId } = useContext(contentContext)

    // useEffect(() => {
    //     websitedefaults();
    // }, []);
    // const websitedefaults = async () => {
    //     try {
    //         console.log(tmdbApi);
    //         const response = await tmdbApi.websitedefaults();

    //         console.log(response);
    //     } catch {
    //         console.log("error");
    //     }
    // };
    const emailId=localStorage.getItem("emailid")
    const phoneNumber=localStorage.getItem("phone")

    useEffect(() => {

       if (window.site === undefined) {
           setTimeout(() => {
               if (window.site && window.site.common && window.site.common.imageCloudfront) {
                   setImg(window.site.common.imageCloudfront)
               }
           }, 1000);
       }
       if (window.site && window.site.common && window.site.common.imageCloudfront) {
           setImg(window.site.common.imageCloudfront)
       }
   
   
   }, [window.site]);

    useEffect(() => {
        if ((localStorage.getItem("userId"))) {
            GetUserDataSignIn();
        }
    }, []);

   //  const handleKeypress = (e) => {
   //      //it triggers by pressing the enter key

   //      if ((e.key === "Enter")) {
   //          setTimeout(function () {
   //              handleSignIn();
   //              console.log("called");
   //          }, 1000);
   //      }
   //  };

   //  const handleSignIn = (e) => {
   //      console.log("called1");
   //      if (email === "" && pwd === "") {
   //          setError("Please enter Email and Password");
   //          setTimeout(function () { setError("") }, 3000);
   //      }
   //      else if (email === "") {
   //          setError("Please enter Email");
   //          setTimeout(function () { setError("") }, 3000);
   //      }
   //      else if (pwd === "") {
   //          setError("Please enter Password");
   //          setTimeout(function () { setError("") }, 3000);
   //      }
   //      if (email && pwd) {
   //         //  setBtnLoader("loginpwd")
   //          loginPwd();
   //      }
   //  }

    const loginPwd = async () => {
        try {
            
            const response = await tmdbApi.signin({
                "emailid": email,
                "password": pwd,
                "useragent": JSON.parse(localStorage.getItem("loc"))
            });
            console.log(response);
            if (response?.statusCode===200 && response?.result === "Invalid email or password") {
                setError(response?.result);
                setTimeout(function () { setError("") }, 3000);
               //  setBtnLoader("")
            } else if (response?.result === "Session Already Exists") {
                // signoutsession()
                setShowSessionPopup(true)
               //  setBtnLoader("")
            }else if(response?.statusCode===200 && localStorage.getItem("check") ){
                localStorage.setItem("token", response?.result.token.token);
                localStorage.setItem("userId", response?.result.userid);
                GetUserDataSignIn();
                localStorage.setItem("loginTime",moment().format('DD-MMM-YYYY HH:mm:ss'))
                window.location.replace("/viewcontent/" + localStorage.getItem("check"));
                localStorage.removeItem("check");

            } else {
                localStorage.setItem("token", response?.result.token.token);
                localStorage.setItem("userId", response?.result.userid);
                GetUserDataSignIn();
                localStorage.setItem("loginTime",moment().format('DD-MMM-YYYY HH:mm:ss'))
                // navigate("/usermanagement");
            }
           

        } catch {
            console.log("error");
           //  setBtnLoader("")
            setError("Invalid email or password");
            setTimeout(function () { setError("") }, 3000);
        }
    };
    // console.log('userDatauserDatauserData', userData)
    const GetUserDataSignIn = async () => {
        try {

            const response = await tmdbApi.getUserData({});

            if (response?.statusCode === 200) {

                setUserData(response?.result?.[0]);
                localStorage.setItem("ClientName", response?.result?.[0]?.name)
                localStorage.setItem("ClientType", response?.result?.[0]?.type)
                let userArr = response?.result?.[0]?.permissions
                const EMAILID = response?.result?.[0]?.emailid
                console.log('user email',EMAILID)
                window.clarity("set", "orasi_user_email", EMAILID)
                // Clarity.addTag('Orasi User Email', EMAILID);
                const obj = userArr.reduce((acc, item) => {
                    if (item.submenus) acc[item.menu] = false;
                    return acc;
                }, {});
                // console.log('objjjjjjjj--->',obj)

                if(!(localStorage.getItem("check"))){
                let k = response?.result?.[0]

                let permissionList = response && response?.result && response?.result?.[0] && response?.result?.[0]?.permissions
                let filterdList = permissionList.filter((item) => item.display===true)
                const data= filterdList?.filter((value)=>value?.menu==="Dashboard")
                let id = data && data[0] && data[0].menu.split(" ").join("").toLowerCase()

                navigate("/" + id);
                navigate("/users");
                

                setActiveMenuId(data && data[0] && data[0].menuid)
                console.log("activeMenuid------->",data)
                }

                // setActiveMenuObj(obj)
               //  setBtnLoader("")
                // console.log('response?.result?.[0] kkkkkkkkkk', response?.result?.[0])
            }
        } catch {
           //  setBtnLoader("")
            console.log("error");
        }
    };

   //  const forgotPassword = async () => {
   //      try {
   //         //  setBtnLoader("forgotpwd")
   //          const response = await tmdbApi.ForgotPassword({
   //              "emailid": email
   //          });
   //          console.log(response);
   //          if (response?.statusCode===200 && response?.result === "mail sent successfully") {
   //              setSuccess(true);
   //          } else if(response?.statusCode===200 && response?.result === "Email does not exists"){
   //              setError("Email Does Not Exists . Please Enter Valid Email");
   //              setTimeout(function () { setError("") }, 3000);
   //          }else {
   //              setError("Please Enter Email Id");
   //              setTimeout(function () { setError("") }, 3000);
   //          }
   //         //  setBtnLoader("")
   //      } catch {
   //          console.log("error");
   //         //  setBtnLoader("")
   //          setError("Please enter email id");
   //          setTimeout(function () { setError("") }, 3000);
   //      }
   //  };


   //  const handleForgot = (e) => {
   //      if(BtnLoader===""){
   //      forgotPassword();
   //      }
   //  }

   //  function onConfirm() {
   //      setSuccess(false);
   //  };

   //  const handleShowSessionPopup = () => {
   //      setShowSessionPopup(true)
   //  }
    const onCancel = () => {
        setShowSessionPopup(false)
       //  setBtnLoader("")
    }
    const signoutsession = async () => {
        try {
           //  setBtnLoader("sessionLoad")
            const response = await tmdbApi.SignOutUser({ emailId: email });
            console.log(response);
            if (response?.result==="Success") {
                loginPwd()
            } else {
                setError("Invalid Details");
               //  setBtnLoader("")
            }
        } catch {
           //  setBtnLoader("")
            console.log("error");
        }
    }

   //  const handleMessage = (e) => {
   //      setError("");
   //  }
    const handleResendOtp = async () => {
       setOtp("")
       setResendActive(true)
       setTimeout(function(){
         setResendActive(false)
       },3000)
      // setOtpClass(true)
       try {
       //   console.log(tmdbApi);
         const response = await tmdbApi.resendMail({
           "emailId": localStorage.getItem("emailid"),
           
         });
         // setResendActive(false)
         console.log(response);
       } catch {
         setResendActive(false)
   
         console.log("error");
       }
     };
   //   const handleOtpError = (e) => {
   //     console.log("came");
   // setOtpClass(false)
   //   }
    const handleClose=()=>{
       navigate("/")
    }
    const handleRequest = async () => {
     if(otp===""){
setOtpClass(true)
     }else{
       setActiveLoad("verify")
       try {
         // Prepare the request payload
         const payload = {
           emailid: localStorage.getItem("emailid"),
           otp: Number(otp), // Convert OTP to a number
         };
     
         // Make the API call
         const response = await tmdbApi.otpVerify(payload);
     
         // Check the API response
         if (response?.result === "Invalid code entered") {
           setActiveLoad("")
           setOtpClass(true); // Handle invalid OTP
         } else {
           navigate("/thankyou"); // Navigate to the request page
           setActiveLoad("")
         }
     
         console.log(response); // Log the response for debugging
       } catch (error) {
         // Handle errors (e.g., network or server issues)
         setResendActive(false); // Reset resend active state
         console.error("Error during OTP verification:", error);
         setActiveLoad("")
       }
     }
    
     };
     const emailValidation = (e)=> {
       let flag = true;
       const regEx = /[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,8}(.[a-zA-Z{2,8}])?/g;
       if (regEx.test(newEmail)) {
           setError("");
     
       } else if (!regEx.test(newEmail) && newEmail !== "") {
           setError("Email is Not Valid");
           setTimeout(function () { setError("")}, 3000);
           flag = false;
       }
       if (newEmail === "") {
           setError("Please Enter Email");
           setTimeout(function () { setError("")}, 3000);
           flag = false;
       }
       return flag
     
     }
  
     const handleChangeEmail=()=>{
       setNewEmail("")
       setShowEmailChange(true)
     }
     const handleClosePopup=()=>{

       setShowEmailChange(false)
     }
     const handleEmailchange=(e)=>{
       setNewEmail(e.target.value)
     }
   const handleCancel =()=>{
       setShowEmailChange(false)
   }
   const handleSave= async()=>{
       const validate= emailValidation()
       if(validate){
           setActiveLoad("save")
           try {

               const response = await tmdbApi.ChangeEmail({
                   "oldemailid": emailId,
                   "newemailid" : newEmail
               });
               console.log(response);
               if (response?.result === "Email Sent Successfully") {
                   setActiveLoad("")
                   setShowEmailChange(false)
                   // setBtnLoader(false)
                   // setExist(true)
                   setSuccess(true)
                  
   
               }else if(response?.result==="Client Not Found"){
                   setActiveLoad("")
                   setShowEmailChange(false)
                   setNotFound(true)
                   // setBtnLoader(false)
                  
                   // setSendEmail(true)
               }else if(response?.result==="Email Already Exists"){
                   setActiveLoad("")
                   setShowEmailChange(false)
                   setExist(true)
               }
               // else if (response?.result==="PENDING APPROVAL"){
               //     setBtnLoader(false)
               // //    setAlertMsg(true)
               // navigate("/thankyou")
               // }  else {
               //     setBtnLoader(false)
               //     navigate("/verifyaccount")
               // }
           } catch {
               console.log("error");
               setActiveLoad("")
               setError("Invalid email or password");
               setTimeout(function () { setError("") }, 3000);
           }
      console.log("savedddddddddddddddddddddddddddddd")
       }
   }
   const onConfirm=()=>{
       setSuccess(false)
   }
   const onConfirm1=()=>{
setNotFound(false)
   }
   const onExist=()=>{
       setExist(false)
   }
  const  handleChange =(otp)=>{
   setOtp(otp)
   setOtpClass(false);
  }
  return (
   <>
       <Modal className="access-denied" show={showSessionPopup}>
           <div className="modal-body enquiry-form">
               <div className="container">
                   <button
                       className="close-btn"
                       onClick={e => onCancel()}
                       id="access-denied-close-btn"
                   >
                       <span className="material-icons">close</span>
                   </button>
                   <span className="material-icons access-denied-icon" id="access-denied-icon">
                       web_asset_off
                   </span>
                   <h3 id="multiple-sessions-title">Multiple Sessions Found</h3>
                   <p id="multiple-sessions-text">
                       Another session is running in another browser. Do you want to terminate that session?
                   </p>
                   <div className="popup-footer">
                       <button
                           className="fill_btn yellow-gradient"
                           data-bs-toggle="modal"
                           data-bs-target="#recommendModal"
                           onClick={e => signoutsession()}
                           id="yes-terminate-session"
                       >
                           {BtnLoader==="sessionLoad" ? (
                               <img
                                   src={image+"orasi/client/resources/orasiv1/images/common-icons/rotate_right.svg"}
                                   className="loading-icon"
                               />
                           ) : null}
                           Yes
                       </button>
                       <button
                           className="fill_btn"
                           data-bs-toggle="modal"
                           data-bs-target="#recommendModal"
                           onClick={e => onCancel()}
                           id="no-terminate-session"
                       >
                           No
                       </button>
                   </div>
               </div>
           </div>
       </Modal>

       <div className="signin-wrapper" id="signin-wrapper">
           <div className="logo_section" id="logo-section">
               <img
                   src={`${image}${appname}/images/web/logo-dark.png`}
                   className="logo"
                   id="signin-logo"
               />
               <button className="close-btn" onClick={handleClose} id="signin-close-btn">
                   <span className="material-icons">close</span>
               </button>
           </div>
           <div className="signin-body" id="signin-body">
               <div className="signin-graphic" id="signin-graphic">
                   <img
                       src={`${image}${appname}/images/web/Log-in-graphic.svg`}
                       id="signin-graphic-img"
                   />
                   <h3 id="onboarding-title">Seamless Onboarding</h3>
                   <p id="onboarding-subtitle">Successful Beginnings: Your Journey Starts Here!</p>
               </div>

               <div className="signin-section emaillogin verifying-account" id="verify-account-section">
                   <div className="d-flex">
                       <div>
                           <h1 className="bold-heading" id="verify-account-heading">Verify Your account</h1>
                           <p className="mb-3" id="verify-account-text">
                               Enter 5 Digit OTP sent to your Mobile Phone and Email
                             
                           </p>
                          <p> Otp has been sent to: <span className="email-style">{emailId}</span></p>
                       </div>
                     
                   </div>

                   <div className="mb-0 d-flex change-section" id="phone-number-section">
                       <p>
                           <span className="material-symbols-outlined">call</span>
                       </p>
                       <p className="ps-2" id="phone-number-text">{phoneNumber}</p>
                       <a href="#" className="change-txt" data-bs-toggle="modal" data-bs-target="#phonechangemodal" id="change-phone-link">
                           Change
                       </a>

                       <div className="modal fade" id="phonechangemodal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
                           <div className="modal-dialog phonemodal">
                               <div className="modal-content">
                                   <div className="modal-header header-style">
                                       <h5 className="modal-title" id="exampleModalLabel">Edit</h5>
                                       <button type="button" className="close" data-bs-dismiss="modal" aria-label="Close">
                                           <span className="material-symbols-outlined">close</span>
                                       </button>
                                   </div>
                                   <div className="modal-body">
                                       <p className="mb-3">Change Phone Number</p>
                                       <input type="text" className="form-control" placeholder="9653284598" id="phone-change-input" />
                                       <div className="signin-footer mt-2">
                                           <button className="outline_btn mx-2" id="cancel-phone-change">Cancel</button>
                                           <button className="fill-btn" id="save-phone-change">SAVE & SEND OTP</button>
                                       </div>
                                   </div>
                               </div>
                           </div>
                       </div>
                   </div>

                   <div className="otp-blocks mt-5 mb-5" id="signup-otp-blocks">
                       <div className={otpclass ? "otp-inputs block-margin signup-otp-inputs invalid errorStyle" : "otp-inputs block-margin"} id="signup-otp-inputs">
                           <OTPInput
                           className="mb-2"
                               value={otp}
                               onChange={handleChange}
                               autoFocus
                               OTPLength={5}
                               otpType="number"
                               onFocus={() => console.log("Focused!")}
                               id="otp-input-field"
                           />
                           {otp === "" ? (
                               <p id="otp-empty-error">Please enter valid otp</p>
                           ) : (
                               <p id="otp-error">The OTP you have entered is incorrect. Please try again or request a new OTP</p>
                           )}
                       </div>

                       <button className="resend-button" onClick={handleResendOtp} id="resend-otp-button">
                           Resend
                       </button>
                       {resendActive ? (
                           <p
                               style={{
                                   'font-size': '12px',
                                   'color': 'green',
                                   'position': 'absolute',
                                   'left': '80px',
                                   'bottom': '-29%',
                               }}
                               id="otp-resend-msg"
                           >
                               OTP Resent!
                           </p>
                       ) : null}
                   </div>

                 

                 

                   <div className="signin-footer mt-2" id="signin-footer">
                       <button className="fill-btn" onClick={handleRequest} id="verify-btn">
                           {activeLoad==="verify" ? (
                               <img
                                   src={`${image}${appname}/images/web/rotate_right.svg`}
                                   className="loading-icon"
                               />
                           ) : null}
                           VERIFY
                       </button>
                   </div>
                   <span className="errormsg" id="error-msg"></span>
               </div>
               <Modal
 className="modal fade change-email"
 show={showEmailChange}

>

           <div className="modal-dialog phonemodal">
           <div className="modal-content">
                                   <div className="modal-header header-style">
                                       <h5 className="modal-title" id="exampleModalLabel">Edit</h5>
                                       <button type="button" className="close" onClick={handleClosePopup}>
 <span className="material-symbols-outlined">close</span>
</button>


                                   </div>
                                   <div className="modal-body">
                                       <p className="mb-3">Change Email</p>
                                       <input type="text" className="form-control" placeholder="Enter email" name="newemail" value={newEmail} id="email-change-input" onChange={handleEmailchange} />
                                          {error ? (
               <span className="errormsg-floating" style={{
                 fontWeight: 'bold',
                 color: 'red',
               }} id="defaultError">
                 {error}
               </span>
             ) : ""}
                                       <div className="signin-footer mt-2">
                                           <button className="outline_btn mx-2" id="cancel-email-change" onClick={handleCancel}>Cancel</button>
                                           <button className="fill-btn" id="save-email-change" onClick={handleSave}> {activeLoad==="save" ? (
                 <img src={`${image}${appname}/images/web/rotate_right.svg`} className="loading-icon" id="otpLoadingIcon" />
               ) : null}SAVE & SEND OTP</button>
                                       </div>
                                   </div>
                            </div>
                           </div>
       </Modal>
       <SweetAlert show={success}
                   custom
                   confirmBtnText="Ok"
                   confirmBtnBsStyle="primary"
                   title={"Otp Sent Successfully"}
                   onConfirm={e => onConfirm()}
               >
               </SweetAlert>
               <SweetAlert show={notFound}
                   custom
                   confirmBtnText="Ok"
                   confirmBtnBsStyle="primary"
                   title={"Client Not Found"}
                   onConfirm={e => onConfirm1()}
               >
               </SweetAlert>
               <SweetAlert show={exist}
                   custom
                   confirmBtnText="Ok"
                   confirmBtnBsStyle="primary"
                   title={"Email Already Exists"}
                   onConfirm={e => onExist()}
               >
               </SweetAlert>
           </div>
        
       </div>
       <footer className="login_footer" id="login-footer">
               <div className="container-fluid">
                   <p className="footer-para" id="footer-text">
                   © 2025 SpotSaver. All rights reserved. 
                   </p>
               </div>
                </footer>
   </>
);

};

export default VerifyAccount;
